import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type LogoutMutationVariable = {
  snsId : string;
  kakaoAccessToken : string;
  social : string;
  medium?: string | null;
  name : string,
  mobile: string
};

export const usePostKakaoSignUp = (
  options?: UseMutationOptions<any, AxiosError, LogoutMutationVariable>
) => {
  return useMutation<any, AxiosError, LogoutMutationVariable>(
    async ({ snsId, kakaoAccessToken, medium, name, mobile }) => {
      try {
        const response = await request.post('/signup/social', {
          snsId: String(snsId),
          token: kakaoAccessToken,
          social : "kakao",
          medium,
          name,
          mobile
        });
        
        return response.data
      } catch(e){
        //@ts-ignore
        // console.log(e)
      }
    },
    {
      ...options
    }
  )
}

export default usePostKakaoSignUp;